import React from 'react';

const GeometricAnimation = () => {
  // Container for the entire animation
  const animationContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#1a1a2e', // Dark background for contrast
    fontFamily: 'Inter, sans-serif',
    overflow: 'hidden',
    padding: '20px',
    boxSizing: 'border-box',
  };

  // Style for individual animated elements
  const commonShapeStyle = {
    position: 'absolute',
    borderRadius: '10px',
    opacity: 0, // Start invisible
    transform: 'scale(0) rotate(0deg) translateX(0px) translateY(0px)', // Start small and unrotated
  };

  // Specific styles for each shape with unique colors and initial positions
  const squareStyle = {
    ...commonShapeStyle,
    width: '80px',
    height: '80px',
    backgroundColor: '#e94560', // Red
    top: '20%',
    left: '20%',
    animation: 'squareAnim 4s infinite ease-in-out',
    animationDelay: '0s',
  };

  const circleStyle = {
    ...commonShapeStyle,
    width: '70px',
    height: '70px',
    backgroundColor: '#0f3460', // Dark Blue
    borderRadius: '50%',
    top: '50%',
    left: '50%',
    animation: 'circleAnim 4s infinite ease-in-out',
    animationDelay: '0.5s',
  };

  const triangleStyle = { // Using CSS border trick for triangle
    ...commonShapeStyle,
    width: 0,
    height: 0,
    borderLeft: '50px solid transparent',
    borderRight: '50px solid transparent',
    borderBottom: '86.6px solid #533483', // Purple
    borderRadius: '0', // Override commonShapeStyle borderRadius
    top: '70%',
    left: '30%',
    animation: 'triangleAnim 4s infinite ease-in-out',
    animationDelay: '1s',
  };

  const diamondStyle = { // Using rotation for diamond
    ...commonShapeStyle,
    width: '60px',
    height: '60px',
    backgroundColor: '#e6e6e6', // Light Gray
    transform: 'rotate(45deg)', // Initial rotation for diamond shape
    top: '40%',
    left: '70%',
    animation: 'diamondAnim 4s infinite ease-in-out',
    animationDelay: '1.5s',
  };

  // Define keyframe animations as strings
  const keyframes = `
    @keyframes squareAnim {
      0% { opacity: 0; transform: scale(0) rotate(0deg) translateX(0px) translateY(0px); }
      25% { opacity: 1; transform: scale(1) rotate(90deg) translateX(50px) translateY(-50px); }
      50% { opacity: 0.8; transform: scale(0.8) rotate(180deg) translateX(0px) translateY(0px); }
      75% { opacity: 1; transform: scale(1.2) rotate(270deg) translateX(-50px) translateY(50px); }
      100% { opacity: 0; transform: scale(0) rotate(360deg) translateX(0px) translateY(0px); }
    }

    @keyframes circleAnim {
      0% { opacity: 0; transform: scale(0) translateX(0px) translateY(0px); }
      25% { opacity: 1; transform: scale(1.2) translateX(-70px) translateY(30px); }
      50% { opacity: 0.7; transform: scale(0.9) translateX(0px) translateY(0px); }
      75% { opacity: 1; transform: scale(1.1) translateX(70px) translateY(-30px); }
      100% { opacity: 0; transform: scale(0) translateX(0px) translateY(0px); }
    }

    @keyframes triangleAnim {
      0% { opacity: 0; transform: scale(0) translateY(0px); }
      25% { opacity: 1; transform: scale(1) translateY(-60px); }
      50% { opacity: 0.9; transform: scale(0.8) translateY(0px); }
      75% { opacity: 1; transform: scale(1.1) translateY(60px); }
      100% { opacity: 0; transform: scale(0) translateY(0px); }
    }

    @keyframes diamondAnim {
      0% { opacity: 0; transform: scale(0) rotate(45deg); }
      25% { opacity: 1; transform: scale(1) rotate(135deg); }
      50% { opacity: 0.6; transform: scale(0.7) rotate(225deg); }
      75% { opacity: 1; transform: scale(1.1) rotate(315deg); }
      100% { opacity: 0; transform: scale(0) rotate(405deg); }
    }
  `;

  return (
    <div style={animationContainerStyle}>
      {/* Inject keyframes into the document */}
      <style>{keyframes}</style>

      <h1 style={{ color: '#e6e6e6', marginBottom: '50px', fontSize: '2.5rem', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
        Geometric Animation
      </h1>

      <div style={{ position: 'relative', width: '80%', height: '400px', border: '2px solid #533483', borderRadius: '15px', overflow: 'hidden' }}>
        <div style={squareStyle}></div>
        <div style={circleStyle}></div>
        <div style={triangleStyle}></div>
        <div style={diamondStyle}></div>
      </div>
    </div>
  );
};

export default GeometricAnimation;
